// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

#edit-tags-dialog {
  padding: 32px 0;
}
#edit-tags-dialog .heading {
  text-transform: none !important;
  font-size: 1.6rem;
  letter-spacing: 0.032rem;
  font-weight: bold;
  color: #515554;
  margin-left: 24px;
}
#edit-tags-dialog p {
  letter-spacing: 0.028rem;
  color: #696969;
  margin: 0 24px;
}
#edit-tags-dialog #sticker-tag-form-list {
  max-height: 60vh;
  overflow-y: auto;
  margin-block: 20px;
}
#edit-tags-dialog #sticker-tag-form-list .sticker-tag-form {
  margin-inline: 24px;
}
#edit-tags-dialog #sticker-tag-form-list .sticker-tag-form .image-container {
  display: inline-block;
  height: 4rem;
  width: 4rem;
  border-radius: 4px;
  background-color: white;
  margin-right: 16px;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.06), 0px 1px 3px rgba(16, 24, 40, 0.1);
}
#edit-tags-dialog #sticker-tag-form-list .sticker-tag-form .image-container img {
  height: 4rem;
  width: 4rem;
  padding: 4px;
  -o-object-fit: contain;
     object-fit: contain;
}
#edit-tags-dialog #sticker-tag-form-list .sticker-tag-form .sticker-name {
  font-size: 1.6rem;
  font-weight: 600;
  letter-spacing: 0.032rem;
  text-overflow: ellipsis;
}
#edit-tags-dialog #sticker-tag-form-list .sticker-tag-form .tag-input {
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/Global/Stickers/StickerEditTagsModal.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;AAAA;EAGE,eAAA;AACF;AACE;EACE,+BAAA;EACA,iBAAA;EACA,wBAAA;EACA,iBAAA;EACA,cDDO;ECEP,iBAVmB;AAWvB;AAEE;EACE,wBAAA;EACA,cDfY;ECgBZ,cAAA;AAAJ;AAGE;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;AADJ;AAGI;EACE,mBAzBiB;AAwBvB;AAGM;EACE,qBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iFAAA;AADR;AAGQ;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;KAAA,mBAAA;AADV;AAKM;EACE,iBAAA;EACA,gBAAA;EACA,wBAAA;EACA,uBAAA;AAHR;AAMM;EACE,gBAAA;AAJR","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import '~/Styles/Colors';\n\n#edit-tags-dialog {\n  $horizontal-padding: 24px;\n\n  padding: 32px 0;\n\n  .heading {\n    text-transform: none !important;\n    font-size: 1.6rem;\n    letter-spacing: 0.032rem;\n    font-weight: bold;\n    color: $darkGray;\n    margin-left: $horizontal-padding;\n  }\n\n  p {\n    letter-spacing: 0.028rem;\n    color: $darkTextColor;\n    margin: 0 $horizontal-padding;\n  }\n\n  #sticker-tag-form-list {\n    max-height: 60vh;\n    overflow-y: auto;\n    margin-block: 20px;\n\n    .sticker-tag-form {\n      margin-inline: $horizontal-padding;\n\n      .image-container {\n        display: inline-block;\n        height: 4rem;\n        width: 4rem;\n        border-radius: 4px;\n        background-color: white;\n        margin-right: 16px;\n        box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.06), 0px 1px 3px rgba(16, 24, 40, 0.1);\n\n        img {\n          height: 4rem;\n          width: 4rem;\n          padding: 4px;\n          object-fit: contain;\n        }\n      }\n\n      .sticker-name {\n        font-size: 1.6rem;\n        font-weight: 600;\n        letter-spacing: 0.032rem;\n        text-overflow: ellipsis;\n      }\n\n      .tag-input {\n        margin-top: 10px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
